/* js/accordion.js */

jQuery( document ).ready(function( $ ) {



    /*var s,
        AppAccord = {

            settings: {
                numArticles: 5,
                isOpen: false,
                context: '.js-accordion',
                question: $('.js-question'),
                answer: $('.js-answer'),
                openClass: 'js-accordion-open',
            },

            init: function() {
                s = this.settings;
                this.bindUIActions();
            },

            bindUIActions: function() {
                s.question.on("click", function() {
                    AppAccord.getMoreArticles(s.numArticles);
                });
            },


            setContext: function (context) {
                s.context = context;
            },

            getContext: function () {
                return s.isOpen
            },


            setIsOpen: function (isOpen) {
                s.isOpen = isOpen;
            },

            getIsOpen: function () {
                return s.isOpen
            },

            openQuestion: function (el) {
                el.slideDown('fast');
                s.context.addClass(s.openClass);
                AppAccord.setIsOpen(true);
            },

            getMoreArticles: function(numToGet) {
                // $.ajax or something
                // using numToGet as param
            },



        };*/






    var question = $('.js-accordion .js-question');
    var answer = $('.js-accordion .js-answer');

    $(question).click(function(){
        $(answer).slideUp('fast');
        $(answer).parent().removeClass('js-accordion-open');

        if($(this).next().is(':hidden')){
            $(this).next().slideDown('fast');
            $(this).parent().addClass('js-accordion-open');
        }

    });


});




